import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const AlertText = styled.div`
  margin-bottom: 9px;
  display: flex;
  flex-direction: column;
`

export const AlertTitle = styled.div`
  font-weight: 600;
`

export const DangerLink = styled(Link)`
  background-color: transparent;
  color: #ec5765;
  font-weight: 600;
  padding-left: 0;
  &:hover {
    color: #ec5765;
  }
`

export const WrapperText = styled.div`
  display: flex;
`

export const DangerButton = styled.span`
  margin-right: 5px;
  margin-left: 5px;
  background-color: transparent;
  color: #ec5765;
  font-weight: 600;
  padding-left: 0;
  cursor: pointer;
  &:hover {
    color: #ec5765;
  }
`

export const WarningLink = styled(Link)`
  background-color: transparent;
  color: #f19236;
  font-weight: 600;
  padding-left: 0;
  &:hover,
  &:active,
  &:visited {
    color: #f19236;
  }
`

export const WarningButton = styled.button`
  background-color: transparent;
  color: #f19236;
  font-weight: 600;
  padding-left: 0;
  &:hover,
  &:active,
  &:visited {
    color: #f19236;
  }
`
